(function () {
  // Remove parent + kit child together via Cart API, then reload the page.
  // The plain /cart/change?line=X link can't be used because it only removes by
  // position index and would leave the kit child orphaned in the cart.
  document.querySelectorAll('.js-kit-remove').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();

      const parentKey = btn.dataset.parentKey;
      const kitGroupId = btn.dataset.kitGroupId;
      const kitChildInputs = document.querySelectorAll(
        '.js-kit-child-qty[data-kit-group-id="' + kitGroupId + '"]'
      );

      const updates = {};
      if (parentKey) updates[parentKey] = 0;
      kitChildInputs.forEach(function (input) { updates[input.dataset.key] = 0; });

      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
      })
        .then(function () { window.location.reload(); })
        .catch(function (err) { console.error('Failed to remove kit:', err); });
    });
  });

  // "Remove kit, keep product" — zeroes out kit children, strips _kit_* properties from parent.
  // Delegated on document (not queried once at load) because the cart page re-renders its
  // item list via the section-rendering API on every quantity/remove action, which would
  // otherwise orphan a directly-bound listener. ":not([data-drawer])" excludes the cart
  // drawer's own kit row, which is handled separately in component-cart-quantity.js.
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.js-kit-dekit:not([data-drawer])');
    if (!btn) return;
    e.preventDefault();
    const parentKey = btn.dataset.parentKey;
    const kitGroupId = btn.dataset.kitGroupId;

    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });

      const kitChildren = cart.items.filter(function (item) {
        const props = item.properties || {};
        return props._kit_group_id === kitGroupId && props._kit_is_child === 'true';
      });

      const mainItem = cart.items.find(function (item) { return item.key === parentKey; });
      if (!mainItem) return;

      const cleanedProps = {};
      Object.keys(mainItem.properties || {}).forEach(function (k) {
        if (!k.startsWith('_kit_')) cleanedProps[k] = mainItem.properties[k];
      });

      if (kitChildren.length > 0) {
        const updates = {};
        kitChildren.forEach(function (c) { updates[c.key] = 0; });
        await fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parentKey, quantity: mainItem.quantity, properties: cleanedProps })
      });

      window.location.reload();
    } catch (err) {
      console.error('Failed to remove kit:', err);
    }
  });
})();
